import React from 'react';

import { Content as CommonContent } from '../common/Types.jsx';
import { withBlockRendering } from '../utility/Config.jsx';
import CellItemContainer from '../common/CellItemContainer.jsx';
import { Component as PaymentMetaComponent, TypeConfig as PaymentMetaTypeConfig } from './PaymentCreditCellMeta.jsx'
import Name from '../utility/Name.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

// #region CONTAINER

const Blocks = {
    get: (group, data) => [
        ...CommonContent.get(group),
        {
            id: Name.Block.PaymentCredit.Amount,
            component: PaymentMetaComponent,
            config: {
                Block: PaymentMetaTypeConfig.panel.block(Utilities.wrapTextForEditor({ text: `{${Token.Payment.Amount}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}")}`, token: Token.Payment.Amount })),
                Style: PaymentMetaTypeConfig.panel.style()
            },
            display: 'Amount',
            group,
            image: ''
        },
        {
            id: Name.Block.PaymentCredit.Date,
            component: PaymentMetaComponent,
            config: {
                Block: PaymentMetaTypeConfig.panel.block(Utilities.wrapTextForEditor({ text: `{${Token.Date}("before":"","after":"")}`, token: Token.Date })),
                Style: PaymentMetaTypeConfig.panel.style()
            },
            display: 'Date',
            group,
            image: ''
        },
        {
            id: Name.Block.PaymentCredit.Method,
            component: PaymentMetaComponent,
            config: {
                Block: PaymentMetaTypeConfig.panel.block(Utilities.wrapTextForEditor({ text: `{${Token.Payment.Method}("before":"","after":"")}`, token: Token.Payment.Method })),
                Style: PaymentMetaTypeConfig.panel.style()
            },
            display: 'Method',
            group,
            image: ''
        }
    ]
}
const PaymentCreditContainer = withBlockRendering(CellItemContainer, Blocks.get(), (props, block) => {
    if (!block.type) {
        return;
    }
    switch (block.type.value) {
        case Name.Block.Columns:
            if (block.config && block.config.Block && block.config.Block.renderHeaderOnlyFirst) {
                return { renderHeader: props.index == 0 }
            }
    }
});
const TypeConfig = {
    defaultDesign: (type, data) => ({
        "Config": {
            "blocks": [
                {
                    "config": {
                        "Block": {
                            "columnCount": "3",
                            "collapseIfEmpty-col1": false,
                            "alignmentHeader-col1": "tl",
                            "alignment-col1": "tl",
                            "width-col1": {
                                "unit": "%",
                                "value": "33.33"
                            },
                            "alignmentHeader-col2": "tl",
                            "alignment-col2": "tl",
                            "width-col2": {
                                "unit": "%",
                                "value": "33.33"
                            },
                            "alignmentHeader-col3": "tl",
                            "alignment-col3": "tl",
                            "width-col3": {
                                "unit": "%",
                                "value": "33.33"
                            },
                            "designHeader-col1": Utilities.wrapTextForEditor({ tag: Name.Stylesheet.Header2, text: 'Date' }),
                            "designHeader-col2": Utilities.wrapTextForEditor({ tag: Name.Stylesheet.Header2, text: 'Method' }),
                            "designHeader-col3": Utilities.wrapTextForEditor({ tag: Name.Stylesheet.Header2, text: 'Amount' }),
                            "renderHeaderOnlyFirst": true,
                            "spacing": {
                                "unit": "px",
                                "value": "10"
                            }
                        },
                        "Style": {}
                    },
                    "dataType": "layout",
                    "id": `${Name.Block.Columns}-${new Date().getTime()}`,
                    "type": {
                        "value": "columns"
                    },
                    "blocks": [
                        [
                            {
                                "config": {
                                    "Block": {
                                        "design": Utilities.wrapTextForEditor({ text: `{${Token.Date}("before":"","after":"")}`, token: Token.Date })
                                    },
                                    "Style": {}
                                },
                                "id": `${Name.Block.PaymentCredit.Date}-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.PaymentCredit.Date
                                }
                            }
                        ],
                        [
                            {
                                "config": {
                                    "Block": {
                                        "design": Utilities.wrapTextForEditor({ text: `{${Token.Payment.Method}("before":"","after":"")}`, token: Token.Payment.Method })
                                    },
                                    "Style": {}
                                },
                                "id": `${Name.Block.PaymentCredit.Method}-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.PaymentCredit.Method
                                }
                            }
                        ],
                        [
                            {
                                "config": {
                                    "Block": {
                                        "design": Utilities.wrapTextForEditor({ text: `{${Token.Payment.Amount}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}")}`, token: Token.Payment.Amount })
                                    },
                                    "Style": {}
                                },
                                "id": `${Name.Block.PaymentCredit.Amount}-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.PaymentCredit.Amount
                                }
                            }
                        ]
                    ]
                }
            ]
        },
        "Type": type
    })
}

// #endregion CONTAINER

export {
    Blocks,
    PaymentCreditContainer as Component,
    TypeConfig
}